var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-3"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('student-marks-calendar-wrapper')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }